import { format } from 'date-fns';
import { nl } from 'date-fns/locale';
import { PLCustomerData, PLCustomerGender } from 'types/plCustomerData';

export const transformSalutation = (salutation: PLCustomerGender) =>
	salutation === 'MALE' ? 'Dhr.' : 'Mevr.';

export const mapUserInformationToDescriptionListItems = (customer: PLCustomerData) => {
	const address = `${customer.street || ''} ${customer.houseNumber || ''}${
		customer.houseNumberSuffix || ''
	}`;
	const postalCodeAndCity = `${customer.postalCode || ''} ${customer.city || ''}`;

	const name = `${transformSalutation(customer.gender)} ${customer.initials || ''} ${
		customer.lastNamePrefix || ''
	} ${customer.lastName || ''}`;

	const items = [
		{
			key: 'Naam',
			value: name,
		},
	];

	// TODO: the filled out date of birth in case it is missing needs a separate field in the store, like the other missing fields
	if (customer.birthdate) {
		items.push({
			key: 'Geboortedatum',
			value: format(new Date(customer.birthdate), 'P', { locale: nl }),
		});
	}

	items.push({
		key: 'Adres',
		value: `${address} ${postalCodeAndCity}`,
	});

	if (customer.phoneNumber) {
		items.push({
			key: 'Telefoonnummer',
			value: customer.phoneNumber,
		});
	}

	if (customer.email) {
		items.push({ key: 'Email', value: customer.email });
	}

	const membershipItem = {
		key: 'Lidmaatschap',
		value: customer.isMember ? 'Ja, je bent ANWB-lid' : 'Nee, je heb nog geen ANWB-lidmaatschap',
	};
	items.push(membershipItem);

	return items;
};
